class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.showOnPx = 100;
      this.goToTop = () => {
        document.body.scrollIntoView({
          behavior: "smooth"
        });
      };
    }
  
    connectedCallback() {
      this.backToTopButton = this.querySelector(".back-to-top");
      if (this.backToTopButton) {
        document.addEventListener("scroll", () => {
          const bodyHeight = document.body.offsetHeight;
          const windowHeight = window.innerHeight;
          const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
          const bottomOfPage = bodyHeight - windowHeight - this.showOnPx;
  
          if (scrollPosition > this.showOnPx && scrollPosition < bottomOfPage) {
            const percentage = Math.round((scrollPosition - this.showOnPx) / (bottomOfPage - this.showOnPx) * 100);
            this.classList.add("back_top_enable");
            this.style.setProperty('--rotation', `${360 * percentage / 100}deg`);
          } else if (scrollPosition <= this.showOnPx) {
            this.classList.remove("back_top_enable");
            this.style.setProperty('--rotation', `0deg`);
          }
        });
  
        this.backToTopButton.addEventListener("click", this.goToTop);
      }
    }
  }
customElements.define("back-to-top", BackToTop);
  
  